// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';
import ResourceLinkSchema from './resource-link-schema';
import Int64LookupSchema from './int64-lookup-schema';

const schema = {
  $id: '/building-list-schema',
  type: 'object',
  required: ['id', 'sortOrder'],
  properties: {
    id: {
      type: 'integer',
    },
    links: {
      type: 'array',
      nullable: true,
      items: { ...ResourceLinkSchema },
    },
    caption: {
      type: 'string',
      nullable: true,
    },
    details: {
      type: 'array',
      nullable: true,
      items: {
        type: 'string',
      },
    },
    group: {
      ...Int64LookupSchema,
    },
    sortOrder: {
      type: 'integer',
    },
    shortName: {
      type: 'string',
      nullable: true,
    },
    city: {
      type: 'string',
      nullable: true,
    },
  },
} as IJSONSchema;

export default schema;
